<script>
export const pageName = 'membership';
export const pageRoute = '/membership';
export const title = 'UKRA membership'
export const requireMembership = false;
export const requireCompleteAccount = true;

import { getCurrentUserId } from '../../js/auth.js';
import { commands } from '../../js/lib/functions.js';
import { listenToProjection } from '@trullock/firebase-client';
import { PageShowError } from '@trullock/page-manager'
import { loadStripe } from '../../js/utils/stripe.js'
import DateTime from '../../../functions/lib/dateTime.js'
import UserView from '../../../functions/domain/users/userView.js';
import { getMembershipImportDate } from '../../../functions/src/site.config.js';

export default {
	data() {
		return {
			currentUser: null,
			mode: null,
			importDate: getMembershipImportDate(),
			ready: false
		}
	},

	methods: {
		async boot(opts) {
			await listenToProjection([UserView, getCurrentUserId()], user => this.currentUser = user);
			this.stripe = await loadStripe();
			this.ready = true;
		},

		async show(opts) {
			if(this.currentUser.membership.status == 'active' && (DateTime.today.month < 12 || this.currentUser.membership.expiresOn.year > DateTime.today.year))
				throw new PageShowError('/', 'You already have an active membership', {}, 'replace');

			let response = await commands.users.payment.createMembershipSession();
			this.checkout = await this.stripe.initEmbeddedCheckout({
				fetchClientSecret: () => response.client_secret
			});

			this.checkout.mount(this.$refs.stripeMount);
		},

		hide()
		{
			this.checkout?.destroy();
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row">
			<div class="col col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Membership</h4>
					</div>
					<div class="card-body">
						<div ref="stripeMount"></div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
